import React from 'react';
import { Flex as RebassFlex } from 'rebass';

/**
 * See the note in `../Box/Box.js` — `forwardRef` in a `.js` file infers no
 * props, so they have to be stated. This is a pure passthrough to Rebass.
 *
 * @type {React.ForwardRefExoticComponent<import('rebass').FlexProps>}
 */
export const Flex = React.forwardRef((props, ref) => (
  <RebassFlex ref={ref} {...props} />
));
